import { useAnalyticsPageViewTracker } from '@cp-shared-19/frontend-ui';
import React from 'react';
import { RegistrationUi } from './ui';

export const Registration: React.FC = () => {
    useAnalyticsPageViewTracker('confirmIdentity');

    return <RegistrationUi />;
};
